import DomEventHelper from '@/helpers/DomEventHelper';
import { IShoppingCart, IShoppingCartIndividual } from '@/common/interfaces/cart.interface';
import LocalStorageHelper from './OldLocalStorageHelper';

export default class CartHelper {
  public static getMaxAvailableForCart(cartId: number, matchcode: string, maxPerCart: number): number | null {
    let internalMaxPerCart: number | undefined = maxPerCart;
    const cartsInStorage: IShoppingCart = LocalStorageHelper.getCart();
    let amountInCart = 0;
    if(cartsInStorage.shoppingCarts) {
      const cart = cartsInStorage.shoppingCarts.find(shoppingCart => shoppingCart.cartId === cartId);
      if(!cart) {
        return null;
      }
      const items = cart.items.filter(item => item.matchcode === matchcode);
      for(const item of items) {
        amountInCart = item.amount;
        internalMaxPerCart = item.maxPerCart;
      }
    }
    return internalMaxPerCart ? internalMaxPerCart - amountInCart : null;
  }

  public static updateCartCount(count: number): void {
    LocalStorageHelper.setCartItemsCount(count);
    DomEventHelper.fireEvent({ name: `rin-cart-update` });
  }

  public static updateLocalCart(updatedShoppingCart: IShoppingCartIndividual): void {
    const cart = LocalStorageHelper.getCart();
    cart.shoppingCarts = cart.shoppingCarts.filter((shoppingCart: IShoppingCartIndividual) => shoppingCart.cartId !== updatedShoppingCart.cartId);
    cart.shoppingCarts.push(updatedShoppingCart);
    let totalItemsInAllCarts = 0;
    for(const cartItem of cart.shoppingCarts) {
      totalItemsInAllCarts += cartItem.itemsCount;
    }
    cart.totalItemsCount = totalItemsInAllCarts;
    LocalStorageHelper.setCart(cart);
    CartHelper.updateCartCount(totalItemsInAllCarts);
  }
}
